<template>
  <div class="status-changes" v-if="items.length > 0">
    <div class="status-changes__title">Измененния статусов</div>
    <TirPmScrollbar :show-on-hover="true" :style="{ 'max-height': '15rem' }">
      <div class="status-changes__row" v-for="(item, idx) of items as any">
        <div>
          {{
            moment(item.Job?.DateCreated || item.Container?.DateCreated).format(
              "DD.MM.YYYY HH:mm:ss"
            )
          }}
        </div>
        <div style="min-width: 5rem">
          [{{ item.Type == 1 ? "Container" : "Job" }}]
        </div>
        <div class="status-changes__status">
          <template v-if="item.Type == 1">
            <ContainerStatus
              :type-name="item.Job?.Status || item.Container?.Status"
              :is-full-size="true"
            />
          </template>
          <template v-else>
            <ScheduleStatus
              :type-name="item.Job?.Status || item.Container?.Status"
              :is-full-size="true"
            />
          </template>
        </div>
        <div
          class="status-changes__message"
          :title="item?.Job?.Message || item?.Container?.Message"
        >
          {{ item?.Job?.Message || item?.Container?.Message }}
        </div>
      </div>
    </TirPmScrollbar>
  </div>
</template>

<script setup lang="ts">
// Импорты из Vue 3 Composition API
import EnumJobContainerStatus from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/database/enums/EnumJobContainerStatus";
import EnumJobStatus from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/database/enums/EnumJobStatus";
import ContainerStatusHistoryItem from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/containers/ContainerStatusHistoryItem";
import JobStatusHistoryItem from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/jobs/histories/status/JobStatusHistoryItem";
import EnumCodeTestStatus from "@/api/TestManager/dataSource/api/test-manager/data/entities/EnumCodeTestStatus";
import { ScheduleStatus } from "@/pages/_uc/schedule-status";
import ContainerStatus from "@/pages/_uc/schedule-status/container-status.vue";
import moment from "moment";
import { TirPmScrollbar } from "tir-components";
import { ref, computed, defineProps, defineEmits, onMounted, watch } from "vue";

// Определение пропсов компонента
const props = defineProps({
  items: { type: Array<JobStatusHistoryItem | ContainerStatusHistoryItem> },
});

const isContainer = ref(true);
// Определение эмиттеров событий компонента
const emits = defineEmits<{
  clickLogout: []; // Событие при клике на кнопку "Выход"
  "update:message": [string]; // Событие обновления сообщения
}>();
</script>

<style lang="scss">
.status-changes {
  border-radius: 0.5rem;
  padding: 0.75rem;
  margin-top: 0.5rem;
  border: 0.063rem solid var(--text-secondary);
  background-color: var(--bg-base);
  width: 100%;
  min-height: 10rem;
  .status-changes__title {
    margin-bottom: 0.7rem;
    font-size: 0.75rem;
  }
  .status-changes__row {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    .status-changes__status {
      min-width: 12rem;
    }
    .status-changes__message {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
